import styles from "./LazyLoading.module.css";

export default function LazyLoading() {
  return (
    <div aria-busy="true" className="grow">
      <div className={styles.bar}></div>
    </div>
  );
}
